import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const EditAppointmentPricing = () => {
  const [type, setType] = useState("");
  const [price, setPrice] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  // Fetch the existing appointment pricing data
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/pricing/appointment/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        const data = response.data?.data;
        setType(data.type);
        setPrice(data.price);
      })
      .catch((error) => {
        console.error("Error fetching appointment pricing details:", error);
        alert("Failed to fetch appointment pricing details.");
      });
  }, [id, API_BASE_URL]);

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Prepare the updated data payload
    const payload = {
      type,
      price,
    };

    axios
      .put(`${API_BASE_URL}/admin/pricing/appointment/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then(() => {
        alert("Appointment pricing updated successfully!");
        navigate("/all-appointment-pricing");
      })
      .catch((error) => {
        console.error("Error updating appointment pricing:", error);
        alert("Failed to update appointment pricing. Please try again.");
      });
  };

  const handleAddAppointmentPricing = () => {
    navigate("/add-appointment-pricing");
  };

  const handleViewAllAppointmentPricing = () => {
    navigate("/all-appointment-pricing");
  };

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Appointment Pricing</h5>
          <div className="subjectdiv2">
            <button
              className="handleNewSubject"
              onClick={handleAddAppointmentPricing}
            >
              + Add New Appointment Pricing
            </button>
            <button
              className="allSubjects"
              onClick={handleViewAllAppointmentPricing}
            >
              All Appointment Pricing
            </button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">Edit Appointment Pricing Details</h4>
          <form
            className="subject-detail-form"
            encType="multipart/form-data"
            onSubmit={handleSubmit}
          >
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Type</label>
              </div>
              <select
                className="select-dropdown"
                value={type}
                onChange={(e) => setType(e.target.value)}
                required
              >
                <option value="">-Select Type-</option>
                <option value="online">Online</option>
                <option value="offline">Offline</option>
              </select>
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Price</label>
              </div>
              <input
                type="text"
                placeholder="Enter Price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                required
              />
            </div>

            <div className="school-subj-form-btns">
              <button className="btn-search" type="submit">
                Save
              </button>
              <button
                className="btn-cancel"
                type="button"
                onClick={() => navigate("/all-appointment-pricing")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditAppointmentPricing;
